/**
 * This component will be responsible for handling filtering and sorting of a single category products
 */

import { useEffect, useState, useRef } from 'react';
import { SORTING_OPTIONS, FILTER_OPTIONS } from '@/utils/constants';
import { useDispatch } from 'react-redux';
import { setCatalogProductFilter } from '@/redux/actions';

const FilterAndSorting = props => {
  const ref = useRef(null);
  const dispatch = useDispatch();
  const [selectedSortOption, setSelectedSortOption] = useState({});
  const [isHideOutOfStock, setIsHideOutOfStock] = useState(false);
  const [openDropdown, setOpenDropdown] = useState(false);

  useEffect(() => {
    document.addEventListener('mousedown', handleClickOutside);
    return () => {
      document.removeEventListener('mousedown', handleClickOutside);
    };
  }, []);

  const onFilterSelection = (e, option) => {
    e.stopPropagation();
    setOpenDropdown(false);
    setSelectedSortOption(option);
    setSelectedFilterInReducer(isHideOutOfStock, option);
  };

  const toggleHideOutOfStock = e => {
    e.stopPropagation();
    setIsHideOutOfStock(!isHideOutOfStock);
    setSelectedFilterInReducer(!isHideOutOfStock, selectedSortOption);
  };

  function setSelectedFilterInReducer(hideOutOfStock, sortOption) {
    const dataToSet = {
      is_hide_out_of_stock: hideOutOfStock,
      sort_option: sortOption,
    };
    dispatch(setCatalogProductFilter(dataToSet));
  }

  const dropdownClick = () => {
    setOpenDropdown(s => !s);
  };

  const handleClickOutside = e => {
    if (ref.current && ref.current.contains(e.target)) {
      return;
    }
    setOpenDropdown(false);
  };

  return (
    <div
      className={`filter-sorting w-100 ${
        props?.className ? props.className : ''
      }`}
      ref={ref}
      onClick={dropdownClick}
    >
      <div className="filter-sorting__box pointer flex items-center justify-between">
        <p className="mv0">
          Sort: {selectedSortOption?.displayText || 'Default Option'}
        </p>
        <img
          className="ml1"
          alt="dropdown button"
          src={'/assets/images/down-arrow-thin.svg'}
        />
      </div>
      <div
        className={`filter-sorting__dropdown ${openDropdown ? 'active' : ''}`}
      >
        {SORTING_OPTIONS.map((option, index) => (
          <div
            key={index}
            className={`filter-sorting__dropdown--item pointer ${
              option.id === selectedSortOption?.id ? 'active' : ''
            }`}
            onClick={e => onFilterSelection(e, option)}
          >
            {option.displayText}
          </div>
        ))}
        <hr />
        {FILTER_OPTIONS.map((filter, index) => (
          <div
            key={index}
            className={`filter-sorting__dropdown__checkbox-container flex justify-between items-center pointer ${
              isHideOutOfStock ? 'active' : ''
            }`}
            onClick={e => toggleHideOutOfStock(e)}
          >
            <p className="mv0">{filter.displayText}</p>
            <img
              src="/assets/images/checkbox-filled.svg"
              className={isHideOutOfStock ? 'dib' : 'dn'}
            />
            <span
              className={`checkbox-empty ${isHideOutOfStock ? 'dn' : 'dib'}`}
            ></span>
          </div>
        ))}
      </div>
    </div>
  );
};

export default FilterAndSorting;
